export default class Touchpoint {
    public touchpointValue: string;

    public touchpointName: string;

    public preSelect: boolean;

    constructor(touchpointValue: string, touchPointName: string, preSelect: boolean = false) {
      this.touchpointName = touchPointName;
      this.touchpointValue = touchpointValue;
      this.preSelect = preSelect;
    }
}
